import React, { useRef, useEffect } from "react";
import confetti, { type GlobalOptions, type Options as ConfettiOptions, type CreateTypes as ConfettiInstance } from "canvas-confetti";

export interface ConfettiProps {
  options?: ConfettiOptions;
  globalOptions?: GlobalOptions;
  manualstart?: boolean;
  className?: string;
}

export const Confetti: React.FC<ConfettiProps> = ({
  options,
  globalOptions = { resize: true, useWorker: true },
  manualstart = false,
  className = "",
}) => {
  const instanceRef = useRef<ConfettiInstance | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (canvasRef.current && !instanceRef.current) {
      instanceRef.current = confetti.create(canvasRef.current, {
        ...globalOptions,
        resize: true,
      });
    }
    return () => {
      if (instanceRef.current) {
        instanceRef.current.reset();
        instanceRef.current = null;
      }
    };
  }, [globalOptions]);

  useEffect(() => {
    if (!manualstart && instanceRef.current) {
      instanceRef.current({
        particleCount: 120,
        spread: 70,
        origin: { y: 0.6 },
        ticks: 250,
        ...options,
      });
    }
  }, [manualstart, options]);

  return (
    <canvas
      ref={canvasRef}
      className={className}
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}
    />
  );
};

export default Confetti; 
